// unit: filter3
import f from "../../../../funcs";
import Operator from "./Operator";


let In = Operator.extend("In", {
    literal: ["in"],

    validateValue(value) {
        return f.isArrOf(this.validateLiteral, value);
    },

    compile2js(left, right) {
        if ( !f.isArray(right) || !right.length ) {
            return "false";
        }

        let value;
        let result = "(";

        for (let i = 0, n = right.length; i < n; i++) {
            value = right[i];
            if ( value == null ) {
                value = null;
            }

            if ( i > 0 ) {
                result += " || ";
            }
            // Доношу логику старых фильтров, на бэке фактически так и работает
            result += `(
                ${left} instanceof Array
                    ? ${left}.some(value => value == ${JSON.stringify(value)})
                    : ${left} == ${JSON.stringify(value)}
            )`;
        }

        result += ")";

        return result;
    }
});

export default In;
